var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(0.661 0.722)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148504",
    "data-name": "Rectangle 148504",
    width: 32,
    height: 32,
    transform: "translate(-0.661 -0.722)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bank-check",
    transform: "translate(0.021 7.619)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_369",
    "data-name": "Ellipse 369",
    cx: 0.589,
    cy: 0.589,
    r: 0.589,
    transform: "translate(29.458 6.31)",
    fill: "#004fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21462",
    "data-name": "Path 21462",
    d: "M30.456,121.179a.6.6,0,0,0-.419-.179H.6a.607.607,0,0,0-.6.6v14.959a.6.6,0,0,0,.6.6H30.038a.6.6,0,0,0,.6-.6v-6.1a.6.6,0,0,0-1.2,0v5.5H1.2V122.2H29.439v9.255a.6.6,0,0,0,1.2,0V121.6A.6.6,0,0,0,30.456,121.179Z",
    transform: "translate(0 -121)",
    fill: "#004fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21463",
    "data-name": "Path 21463",
    d: "M56.156,226H40.6a.6.6,0,1,0,0,1.2H56.156a.6.6,0,1,0,0-1.2Z",
    transform: "translate(-37.607 -219.717)",
    fill: "#004fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21464",
    "data-name": "Path 21464",
    d: "M54.361,266H40.6a.6.6,0,1,0,0,1.2H54.361a.6.6,0,1,0,0-1.2Z",
    transform: "translate(-37.607 -257.324)",
    fill: "#004fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21465",
    "data-name": "Path 21465",
    d: "M40.6,167.2h3.59a.6.6,0,0,0,0-1.2H40.6a.6.6,0,0,0,0,1.2Z",
    transform: "translate(-37.607 -163.307)",
    fill: "#004fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21466",
    "data-name": "Path 21466",
    d: "M383.793,188.394h1.8a.6.6,0,0,0,0-1.2h-.9v-.6a.6.6,0,1,0-1.2,0v.624a1.795,1.795,0,0,0,.3,3.565h.6a.6.6,0,1,1,0,1.2h-1.8a.6.6,0,1,0,0,1.2h.9v.6a.6.6,0,1,0,1.2,0v-.624a1.795,1.795,0,0,0-.3-3.565h-.6a.6.6,0,1,1,0-1.2Z",
    transform: "translate(-359.141 -182.111)",
    fill: "#004fe0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.60146f33b566c4872708c4794e54f484.svg";
export { ForwardRef as ReactComponent };